import { u64 } from "@solana/spl-token";

export const MAX_U64 = () => new u64([255, 255, 255, 255, 255, 255, 255, 255]);
